// SPDX-License-Identifier: AGPL-3.0-only
// Copyright (C) 2026 The 25-ji-code-de Team

/**
 * One-time reindex table for history records saved before the characters
 * list was regrouped by character (2026-09).
 *
 * position = character index in the pre-reorder list,
 * value    = character index in the current list.
 * Applied once in useHistory, then flagged in localStorage.
 */
export const CHARACTER_INDEX_MIGRATION: number[] = [
  0,1,2,3,5,6,7,8,10,11,12,13,15,30,31,32,
  33,35,36,37,38,40,41,42,43,45,58,59,60,61,63,64,
  65,66,68,69,70,71,73,88,89,90,91,93,94,95,96,98,
  99,100,101,103,115,116,117,118,120,121,122,123,125,126,127,128,
  130,144,145,146,147,149,150,151,152,154,155,156,157,159,173,174,
  175,176,178,179,180,181,183,184,185,186,188,189,190,203,204,205,
  206,208,209,210,211,213,214,215,216,218,219,220,236,237,238,239,
  241,242,243,244,246,247,248,249,251,267,268,269,270,272,273,274,
  275,277,278,279,280,282,283,300,301,302,303,305,306,307,308,310,
  311,312,313,315,316,329,330,331,332,334,335,336,337,339,340,341,
  342,344,345,360,361,362,363,365,366,367,368,370,371,372,373,375,
  385,386,387,388,390,391,392,393,395,396,397,398,400,401,413,414,
  415,416,418,419,420,421,423,424,425,426,428,446,447,448,449,451,
  452,453,454,456,457,458,459,461,487,488,489,490,492,493,494,495,
  497,498,499,500,502,503,519,520,521,522,524,525,526,527,529,530,
  531,532,534,535,548,549,550,551,553,554,555,556,558,559,560,561,
  563,575,576,577,578,580,581,582,583,585,586,587,588,590,608,609,
  610,611,613,614,615,616,618,619,620,621,623,624,625,626,637,638,
  639,640,642,643,644,645,647,648,649,650,652,653,654,667,668,669,
  670,672,673,674,675,677,678,679,680,682,683,684,698,699,700,701,
  703,704,705,706,708,709,710,711,713,726,727,728,729,731,732,733,
  734,736,737,738,739,741,742,743,757,758,759,760,762,763,764,765,
  767,768,769,770,772,773,774,207,212,217,221,222,223,224,225,226,
  227,228,229,230,231,232,233,234,235,641,646,651,655,656,657,658,
  659,660,661,662,663,664,665,666,177,182,187,191,192,193,194,195,
  196,197,198,199,200,201,202,671,676,681,685,686,687,688,689,690,
  691,692,693,694,695,696,697,491,496,501,504,505,506,507,508,509,
  510,511,512,513,514,515,516,517,518,148,153,158,160,161,162,163,
  164,165,166,167,168,169,170,171,172,4,9,14,16,17,18,19,
  20,21,22,23,24,25,26,27,28,29,702,707,712,714,715,716,
  717,718,719,720,721,722,723,724,725,304,309,314,317,318,319,320,
  321,322,323,324,325,326,327,328,62,67,72,74,75,76,77,78,
  79,80,81,82,83,84,85,86,87,34,39,44,46,47,48,49,
  50,51,52,53,54,55,56,57,730,735,740,744,745,746,747,748,
  749,750,751,752,753,754,755,756,761,766,771,775,776,777,778,779,
  780,781,782,783,784,785,786,92,97,102,104,105,106,107,108,109,
  110,111,112,113,114,552,557,562,564,565,566,567,568,569,570,571,
  572,573,574,612,617,622,627,628,629,630,631,632,633,634,635,636,
  271,276,281,284,285,286,287,288,289,290,291,292,293,294,295,296,
  297,298,299,389,394,399,402,403,404,405,406,407,408,409,410,411,
  412,119,124,129,131,132,133,134,135,136,137,138,139,140,141,142,
  143,523,528,533,536,537,538,539,540,541,542,543,544,545,546,547,
  450,455,460,462,463,464,465,466,467,468,469,470,471,472,473,474,
  475,476,477,478,479,480,481,482,483,484,485,486,579,584,589,591,
  592,593,594,595,596,597,598,599,600,601,602,603,604,605,606,607,
  333,338,343,346,347,348,349,350,351,352,353,354,355,356,357,358,
  359,364,369,374,376,377,378,379,380,381,382,383,384,417,422,427,
  429,430,431,432,433,434,435,436,437,438,439,440,441,442,443,444,
  445,240,245,250,252,253,254,255,256,257,258,259,260,261,262,263,
  264,265,266,
]
